import { Logo } from "../../../components/Logo";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex w-full items-center z-[2] relative min-h-screen !bg-[url('https://res.cloudinary.com/dhdxukwik/image/upload/v1735552077/ung5jhfp04er86xpqt7m.svg')] bg-cover bg-center bg-no-repeat ">
      <div className="lg:hidden h-[58px] fixed top-0 left-0 w-full flex items-center px-5 bg-surface-secondary border border-border-secondary">
        <Logo className="!text-[25px] !leading-0 tracking-[-1.033px]" />
      </div>
      {children}
    </div>
  );
}
